import { css } from 'twin.macro';
import { useCallback, useEffect, useRef, useState } from 'react';
// import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import Linkify from 'react-linkify';
import { marginColor } from './Checkbox';
import { validateRateFormat } from '../../../../_helpers';
import { ElementStyled } from './styles/ElementStyles';
import BlockInputFieldPreview from './BlockInputField/Preview';
import { getPreviewValueFromBlockInput } from '../PdfTemplatePreview/utils';

const InputFieldCSS = css`
    width: 100%;
    .form-group {
        width: 100%;
        max-width: 100%;
        overflow: auto;
        display: block;
        box-sizing: border-box;
    }
    .form-label {
        margin-bottom: 3%;
    }
    .form-input-textarea {
        width: 50%;
        min-width: 200px;
        max-width: 100%;
        min-height: 40px;
        max-height: 400px;
        resize: both;
        overflow: auto;
        box-sizing: border-box;
        display: inline-block;
        margin-left: 4px;
    }
`;

const InputField = ({
    data,
    isPreview,
    errors,
    error,
    elementRef,
    defaultValue,
    isDisabled,
    currUser = {},
    onChange,
}) => {
    const [rateError, setRateError] = useState(null);
    const validationLength = data.validation?.maxLength?.value;

    if (data.validation?.pattern?.value) {
        data.validation.pattern.value = new RegExp(data.validation?.pattern.value);
    }
    const textareaRef = useRef(null);

    const resizeTextarea = (textarea) => {
        setValue(textarea?.value || '');
        if (!textarea || !textarea?.style) return;
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    };

    const composedRef = useCallback(
        (el) => {
            textareaRef.current = el;
            if (elementRef) {
                const registerFn = elementRef({
                    required: data.hasOwnProperty('required') ? data.required : true,
                    ...(data.validation || {}),
                });
                if (typeof registerFn === 'function') {
                    registerFn(el);
                }
            }
        },
        [elementRef, data]
    );

    const getDefaultValue = () => {
        try {
            // const isAutofieldEnabled = (data?.config?.autofillField || data?.options?.autofillField) && !isPreview;
            // if (isAutofieldEnabled && !defaultValue && !data.value) {
            //     return `${currUser[data?.config?.autofillField || data?.options?.autofillField] || ''}`.trim();
            // }
            return data?.value || defaultValue || '';
        } catch (error) {
            return '';
        }
    };
    const [value, setValue] = useState(getDefaultValue());

    useEffect(() => {
        if (textareaRef?.current || elementRef?.current) {
            const requestAnimationFrameFn = window.requestAnimationFrame ? window.requestAnimationFrame : () => {};
            requestAnimationFrameFn(() => {
                resizeTextarea(textareaRef?.current || elementRef?.current);
            });
        }
    }, [defaultValue]);

    return (
        <ElementStyled className={data?.modified && data?.draftMode ? 'modified' : ''}>
            <div css={InputFieldCSS}>
                <Form.Group controlId={data.name || data._id}>
                    <Form.Label
                        // id="questionField"
                        css={css`
                            margin-bottom: 0 !important;
                        `}
                    >
                        <div className="d-flex flex-row">
                            {data.fieldName}
                            <span css={marginColor}>
                                {(data.hasOwnProperty('required') ? data.required : true) && '*'}
                            </span>
                            {/* <RealTimeAudioTranscribeModal
                                onApplyTranscription={(transcript = '') => {
                                    if (transcript && typeof transcript === 'string') {
                                        setValue((prev) => `${prev} ${transcript}`);
                                    }
                                }}
                                label={data.fieldName}
                            /> */}
                        </div>
                    </Form.Label>
                    <div className="d-flex flex-row justify-content-between">
                        <div style={{ flex: 1 }}>
                            <Form.Control
                                as={data.as || 'textarea'}
                                rows="1"
                                name={!isPreview ? data.name || `InputField-${data._id}` : 'InputField'}
                                ref={composedRef}
                                onInput={(e) => resizeTextarea(e.target)}
                                onBlur={(e) => {
                                    if (data.isRate) {
                                        let value = e.target.value;
                                        if (validateRateFormat(value)) {
                                            setRateError(null);
                                        } else {
                                            setRateError(
                                                'Not valid rate! Please enter only 2 digits after the decimal, eg: 12.32'
                                            );
                                        }
                                    }
                                }}
                                placeholder={data.placeholder}
                                maxLength={data?.maxLength || data?.options?.maxLength || validationLength}
                                disabled={isPreview || isDisabled || data.isDisabled}
                                // defaultValue={getDefaultValue()}
                                className="form-input-textarea"
                                value={value} // Controlled value here
                                onChange={(e) => {
                                    setValue(e.target.value);
                                    resizeTextarea(e.target);
                                    if (onChange) onChange(e.target.value);
                                }}
                            />
                        </div>

                        {data?.options?.enableBlockPreview &&
                            data?.options?.enableBlockInput &&
                            data?.data &&
                            data?.data?.length > 0 && (
                                <div className="ml-4">
                                    <BlockInputFieldPreview
                                        key={value}
                                        componentErrorMessage={'Failed to preview blocks.'}
                                        data={{
                                            data: data?.data || [],
                                            value: JSON.stringify(
                                                getPreviewValueFromBlockInput({
                                                    data: data?.data || [],
                                                    value: value,
                                                    key: 'InputField',
                                                })
                                            ),
                                        }}
                                        isPreview={true}
                                    />
                                </div>
                            )}
                    </div>
                    <div>
                        {data?.options?.maxLength && (
                            <span className="badge badge-warning mr-2">
                                Maximum characters allowed : {data?.options?.maxLength}
                            </span>
                        )}
                    </div>
                    {data.instruction && (
                        <Form.Text
                            className="small text-muted warpIt preStyles"
                            css={css`
                                margin-bottom: 0 !important;
                            `}
                        >
                            <Linkify
                                componentDecorator={(decoratedHref, decoratedText, key) => (
                                    <a target="blank" href={decoratedHref} key={key}>
                                        {decoratedText}
                                    </a>
                                )}
                            >
                                {data.instruction}
                            </Linkify>
                        </Form.Text>
                    )}
                    <Form.Text className="text-danger">
                        {error &&
                            (error.type === 'required' ? error.message || 'This field is required' : error.message)}
                    </Form.Text>
                    <Form.Text className="text-danger">{rateError && rateError}</Form.Text>
                    <Form.Text className="text-danger">
                        {errors && data && errors[data.name || `InputField-${data._id}`]?.message}
                    </Form.Text>
                </Form.Group>
            </div>
        </ElementStyled>
    );
};

InputField.propTypes = {};

export default InputField;
